import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  template: '<div [innerHtml]="content"></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastMessageWrapperComponent {
  @Input() public content: string;
}
